export default __webpack_public_path__ + "static/media/360.770a13b5.png";